module.exports = __webpack_public_path__ + "img/icons_22.4553d717.png";